import React from "react"
import {
  cls3,
  cls4,
  cls5,
  cls6,
  cls7,
  cls8,
  cls9,
  cls10,
  cls11,
  cls12,
  cls13,
} from "./Head.module.scss"

//<defs><clipPath id="clip-path"><rect class={cls1} width="16" height="19"/></clipPath><pattern id="New_Pattern_2" data-name="New Pattern 2" width="16" height="19" patternUnits="userSpaceOnUse" viewBox="0 0 16 19"><rect class={cls1} width="16" height="19"/><g class={cls2}><polygon class={cls3} points="16 22.18 10.5 19 16 15.82 21.5 19 16 22.18"/><polygon class={cls3} points="0 22.18 -5.5 19 0 15.82 5.5 19 0 22.18"/><polygon class={cls3} points="8 12.68 2.5 9.5 8 6.33 13.5 9.5 8 12.68"/><polygon class={cls3} points="16 3.17 10.5 0 16 -3.17 21.5 0 16 3.17"/><polygon class={cls3} points="0 3.17 -5.5 0 0 -3.17 5.5 0 0 3.17"/></g></pattern></defs>.cls1,.cls12{fill:none;}.cls2{clip-path:url(#clip-path);}.cls3{fill:#96969e;}.cls4{isolation:isolate;}.cls5{mix-blend-mode:multiply;}.cls6{fill:url(#New_Pattern_2);}.cls7{fill:#3a3a3a;}.cls8{fill:#a6a867;}.cls9{fill:#c2c2cc;}.cls10,.cls13{fill:#fff;}.cls11{fill:#dadae5;}.cls12,.cls13{stroke:#3a3a3a;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}</style><clipPath id="clip-path"><rect class={cls1} width="16" height="19"/></clipPath><pattern id="New_Pattern_2" data-name="New Pattern 2" width="16" height="19" patternUnits="userSpaceOnUse" viewBox="0 0 16 19"><rect class={cls1} width="16" height="19"/><g class={cls2}><polygon class={cls3} points="16 22.18 10.5 19 16 15.82 21.5 19 16 22.18"/><polygon class={cls3} points="0 22.18 -5.5 19 0 15.82 5.5 19 0 22.18"/><polygon class={cls3} points="8 12.68 2.5 9.5 8 6.33 13.5 9.5 8 12.68"/><polygon class={cls3} points="16 3.17 10.5 0 16 -3.17 21.5 0 16 3.17"/><polygon class={cls3} points="0 3.17 -5.5 0 0 -3.17 5.5 0 0 3.17"/></g></pattern></defs>

export const Head = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1527.54 1225.59">
      <g class={cls4}>
        <g id="Layer_2" data-name="Layer 2">
          <g id="shadow" class={cls5}>
            <path
              class={cls6}
              d="M1074.17,316.93a15,15,0,0,1,11.95-13.9,25.67,25.67,0,0,1,18.15-27.1c14.43-4.31,31,3.36,43.48,10.06,8.9,4.76,17.6,9.9,26.17,15.22a16.62,16.62,0,0,1,6.54-3.95c11.2-3.4,26,2.81,36.47,7.13,5.26,2.18,10.51,4.4,15.79,6.54,5.94,2.41,12.75,4,18.1,7.5,8.59,5.67,12.57,15.16,10.27,25.24-2,9-12.23,17.1-21.55,16.41a45.35,45.35,0,0,1-11.12-2.35c.11,9.44-3.38,19-10.22,25.53-11.74,11.14-27,10-40.92,4.39-19.28-7.7-38-16.13-56-26.52a284.74,284.74,0,0,1-24.84-15.95C1087.57,338.76,1073.43,329.46,1074.17,316.93Zm-26,182.46c11,4.4,23.3,1,33.59-3.72s13.58-20.31,7.71-29.41c-6.81-10.56-18.45-12.76-29.41-7.71,6.1-2.81-2,.83-3.74,1.57l-1,.32a92.64,92.64,0,0,0-11.64,4.77c-6.64,3.25-9.85,11.77-8.93,18.63C1035.83,491.73,1041,496.55,1048.17,499.39ZM520.89,978.73c14.79-36-3.8-73.72-32.82-95.88-33.91-25.89-78.44-24.64-118.76-19.5h-.07v0q-2.67.33-5.32.7c-9.81,1.33-15.5,13.25-14.33,22,1.4,10.47,9.59,16.32,19.65,17.35,1.92.2,8.95,1,9.05,1,4.45.77,8.9,1.43,13.31,2.37a160.81,160.81,0,0,1,16.21,4.44c1.69,8.32,8.67,13.49,17.14,14.1,1.43.1,2.86.28,4.28.39.64.09,1.27.18,1.91.29a64.39,64.39,0,0,1,6.61,1.47l1.13,1,.69.68c-.63,1.85-1.1,3.77-1.73,5.63s-1.27,3.45-1.91,5.18c-.08.21-.14.38-.19.53l-.32.64A155.67,155.67,0,0,1,425.48,959c-.87,1.32-1.77,2.62-2.68,3.9-.47.65-1.17,1.59-1.51,2-2,2.6-4.18,5.06-6.42,7.47a142.22,142.22,0,0,1-14.22,13.22c-.46.36-1.3,1-1.91,1.44-1.29.92-2.58,1.82-3.9,2.69-3.06,2-6.21,4-9.43,5.73-2.77,1.53-5.61,2.89-8.46,4.26l-.76.37-.34.13c-2,.75-3.93,1.5-5.92,2.19-8.88,3.09-15.89,11.95-14.4,21.54l-.71.07c-8.15.63-16.29,1.19-24.47,1.33a329.19,329.19,0,0,1-52.9-3.76c-9-1.32-18-3.09-26.85-5.24-4.29-1-8.53-2.06-12.85-2.91a82.76,82.76,0,0,0-15.71-1.16c-7.42-.08-11.77,9.74-6.19,14.95,3.31,3.09,6.54,6.29,10.46,8.58a92.37,92.37,0,0,0,14.22,6.45q12.78,4.77,26,8.38c18.27,5,37.44,7.53,56.3,8.82a300.72,300.72,0,0,0,109.83-13.38C469.33,1034.63,505.52,1016.14,520.89,978.73ZM48.26,837.15c-11.73,4.66-28.4,9.35-34.28,21.78-4.28,9.06-2.66,20.16,6.7,25.54,12.32,7.08,27.58,2.6,40.5-.45,12.38-2.94,20.91-17.72,17-29.9C74.46,842.72,60.91,832.13,48.26,837.15ZM365.78,415.66c8.59,2,15.85.48,23.84-3.12,38.91-17.54,76.93-36.86,115.15-55.86,19.09-9.49,104.1-52.31,106.57-53.69,6.68-3.73,10.4-8.25,14.86-14.32,6.61-9,5.34-23.35,0-32.48a32.46,32.46,0,0,0-27.79-15.94c-14.52-.06-28.7,9.54-41.52,15.94-9.54,4.75-66.5,33.74-85.45,43.46-37.89,19.46-75.93,38.57-113.06,59.46-14.11,7.94-20.05,28.45-11.1,42.33C351.54,408.05,357.89,413.86,365.78,415.66ZM179.23,306.94A45.73,45.73,0,0,0,192,308c4.9-.27,9-1.67,13.59-3.07a25.48,25.48,0,0,0,14.52-11.17c3-5.2,4.34-12.88,2.45-18.71S217,263.5,211.38,260.53c-5.41-2.86-12.77-4.82-18.72-2.45-8.18,3.26-17,6.3-22.77,13.48-4.85,6.09-7.62,12.67-5.44,20.59C166.34,299,172.13,305.31,179.23,306.94Zm93.24,414a445.62,445.62,0,0,1-61.56,24.51c-10.3,3.31-20.68,6.39-31.09,9.36s-22,6.55-32.64,4.45c-10.34,3.77-21.67-4.74-24.56-14.28a25.85,25.85,0,0,1,2.3-21.42,15,15,0,0,1,4.5-10A114.07,114.07,0,0,1,144,701.47c-7.92-3.1-15.45-7.93-16.91-15.37a13,13,0,0,1,9.45-15.16c4.9-1.35,10.52-.44,15.39.18,7.77,1,15,2,23.78,2,4.72,0,9.41-.29,14.11-.62l1.25-.07,4.14-.82q18.35-10.18,36.85-20.06c-1.18-.38-2.36-.75-3.56-1.09-2.22-.62-4.47-1.16-6.73-1.63-.67-.14-6-.92-4.32-.77-11.24-1.13-22.09.69-31.18-7.69-7.4-6.81-5.64-17.3,0-24.28,9.24-11.44,28.42-8,41-5.86,11.49,1.94,25,5.4,33.7,13.57a33.23,33.23,0,0,1,6.65,8.84l50.29-29.86c16.72-9.92,33.21-20.92,50.53-29.75a21.63,21.63,0,0,1,14-2.13,21.82,21.82,0,0,1,3.29-1.43c6.15-2,13.24-1.6,19.64-1.56a307.63,307.63,0,0,1,31.69,1.91c8.57.95,15.27,5.25,18,13.71,2.68,8.27-2,16.47-8.58,21.09l-48.52,34c7.77-.12,15.79.44,22.59,2.73A23.87,23.87,0,0,1,437,665.16c-.21,6.62-2.54,13.19-5.6,19C419.32,707,393.15,715,369.1,716.1c-11.59.54-23.22.44-34.69-1.44-9.36-1.53-21.2-5.47-26-14C296.7,708,284.78,714.81,272.47,720.9Zm97.45-40.21.18,0c-.26,0,2.27-.34,2.64-.4,1.22-.22,2.44-.45,3.66-.72,2-.45,4.07-1,6.08-1.57-.87.14-1.74.28-2.62.44C376.51,679,373.2,679.81,369.92,680.69ZM728.82,990.4c-15.32-1.39-31.31,2.8-43.06,12.79-5.88,5-7,15.72-2.85,22.08a19.66,19.66,0,0,0,2,2.64l-1.65.75c-16.6,7.36-33.34,14.37-49.78,22.09-32.82,15.42-65.34,32.14-96.12,51.35q-13,8.14-25.86,16.65c-4.43,2.94-8.67,6.12-12.9,9.34-5.16,3.93-8.54,8.48-12,13.89-5.81,9,3.75,18,12.68,16.49a56.21,56.21,0,0,0,18.13-6.09c5.27-2.79,10.41-5.75,15.58-8.71,10.32-5.92,20.8-11.56,31.24-17.29,20.58-11.3,41.38-22.16,62.6-32.25q15.67-7.45,31.6-14.42c2.73-1.19,24.52-10.29,29.87-12.46,11.42-4.62,22.88-9.27,33.88-14.85s23.25-12,30.17-22.37c5.42-8.12,6.27-18.75,1.16-27.24C748,993.67,738.66,991.3,728.82,990.4Zm794.07-436.79c-12.4-25.61-43.65-35.58-68-45.67-6.76-2.8-13.53-5.58-20.33-8.29l-.33-.17a274,274,0,0,0-69.3-23.39c-10.35-2-22.31,2.88-24.87,14.12-2.4,10.53,3.16,22.06,14.12,24.88,21.23,5.45,41.92,12.68,62.31,20.65,2.13,1.07,4.24,2.16,6.33,3.29a251.56,251.56,0,0,1,22,13.4c1.52,1,3,2.09,4.53,3.16.77.55,3.26,2.54,3.35,2.54.68.65,1.37,1.31,2.07,1.92-1-.89-.42-.86.12-.21a2.41,2.41,0,0,1-.08.25l-.39,1.18c.15-.57-.61,1.3-1.31,2.46-.43.71-1,1.39-1.37,2.11l-.11.23-.36.37a102,102,0,0,1-7.88,7.54l-.06.06c-.74.55-1.48,1.1-2.23,1.63q-2.91,2.07-5.92,4c-3.26,2.07-6.62,4-10,5.78q-2.37,1.23-4.79,2.37c-1,.48-2,.93-3.07,1.39l-.29.1c-8.81,2.94-17.37,5.83-26.58,7.39-.87.15-1.76.28-2.63.42l-.83,0c-2,.15-3.88.21-5.84.23a10.59,10.59,0,0,0-1.28-.38c-.91-.22-1.8-.42-2.72-.58a5.92,5.92,0,0,1-.78-.21c.26.13.55.29.92.5-.38-.21-.76-.4-1.14-.58a5.18,5.18,0,0,1-.5-.22c-12.82-5.52-28.93,6.2-24.62,20.68l-1.72-.48c-2.92-.73-5.84-.6-8.73-1a19.91,19.91,0,0,0,.94-3.88c.8-5.94-1.24-10.08-4.79-14.65s-9.19-6.32-14.42-8.18l-1-.36a4,4,0,0,0-.41-.2c-1.71-.77-3.43-1.52-5.12-2.34-6.21-3-12.14-6.59-18-10.2-13.14-8.06-43.57-26.94-43.69-27-.45-.39-.9-.76-1.31-1.17a17.9,17.9,0,0,1-1.38-1.55c-.58-1.24-.94-2.46-.07.59,0-.2-.63-1.69-.91-2.69,0-.19,0-.41,0-.67s.13-1.75.16-2.52c.1-.47.2-.92.24-1.09.36-1.3,2-3.79.08-.73.66-1.08,1.19-2.23,1.87-3.31.51-.82,1.14-1.58,1.62-2.42l.31-.28c7-6.64,11.37-14.95,4.5-23.56-6.48-8.12-19.68-4.22-26.67.85s-11.7,12.15-14.48,20.42a42.33,42.33,0,0,0,11.87,44.77c7.11,6.44,15.48,11.41,23.5,16.61l22.91,14.85a233.38,233.38,0,0,0,21,12.56,103.36,103.36,0,0,0,14.89,6.27,28.27,28.27,0,0,0,11,1.46c8.32,10.83,19.73,19.2,31.87,25.56,8.33,4.36,16.33,6.36,25.72,4.78,6.89-1.16,13.58-3.46,20.19-5.66a623.35,623.35,0,0,0,78.94-32.23c12.22-6,26.22-11.78,36.56-20.82C1529.66,586.74,1530.08,568.47,1522.89,553.61Zm-77.6,414.6c-1.82,6.62-6.68,10.54-12.84,12.85q-41.42,15.5-83.53,29-5.48,1.76-11,3.44,2.71,2.81,5.4,5.54a599.66,599.66,0,0,1,46.62,54.08q10.54,13.73,20.3,28c4.17,6.12,8.69,12.41,8.74,20.18a22.88,22.88,0,0,1-14.4,21.62c-11.28,4.76-23.86,7.43-35.78,10.14-12.5,2.83-25.09,4.91-37.8,6.59-24.44,3.23-50.3,5.78-74.52,0-8.38-2-11.82-11.32-9.79-18.71a21.47,21.47,0,0,1-4.86-6.94,21,21,0,0,1-1.32-11.21c-32,8.27-65.22,11-98.14,13.47-17.35,1.3-34.75,2.27-52.06,4.07-8.92.93-13.79,1.75-22.71,3.13-9.7,1.51-19.33,3.38-29.16,3.4-13.5,0-17.26-17.54-6.63-24.48,8.27-5.4,17.78-8.75,27.56-11.17-7.45-3.26-11.57-12.66-10.55-20.27,1.35-10,9.34-16,19-16.81l101.31-8.1a12,12,0,0,1,1.93-1.06c6.89-3,13-3.77,19.89-.3a21,21,0,0,1,10.63,18.29c14.24,0,28.48-.08,42.72-.2a19.08,19.08,0,0,1,18.78,16.52,115,115,0,0,1,60.74-16.6c-.44-.57-12.54-16.14-16.35-20.93q-12.9-16.15-26.27-31.94a21.48,21.48,0,0,1-14,1.42c-.29-.06-.57-.16-.86-.24-1.67,0-3.36-.08-5.1-.11a13.42,13.42,0,0,1-12.94-10.21c-4.59,3.64-10.53,5.15-17.31,3.61-10.74-2.45-16.57-14.54-14-24.71,2.41-9.62,4.5-19.3,6.18-29.07.41-2.36,1.57-9.79,1.76-11.14.32-2.24.38-2.71.19-1.39s-.13.85.16-1.39c.17-1.36,1-8.83,1.2-11.22q1.35-14.79,1.58-29.67c.07-4.79,0-9.57-.06-14.35v0a20.19,20.19,0,0,1-7.19-15c-.39-8.84,6.58-17,14.75-19.37a23.47,23.47,0,0,1,21,4c29.86,11.56,122.61,47.69,139.12,54.24,16.35,6.49,31.62,13.22,44.82,25.12C1445.36,954.65,1447,962.14,1445.29,968.21Zm-146-38.3-30.91-11.75c0,1.47-.09,2.94-.14,4.41a21.54,21.54,0,0,1,10.59.06c7.08,2,11.68,7.27,14,14,.29.85.55,1.7.79,2.55Zm30.17,193c-1.84-.13-3.68-.22-5.52-.25a115.92,115.92,0,0,0-12.08.61l-.52.11c-1,.21-2,.38-3.08.59-2,.43-4.08.92-6.09,1.48q-2.75.76-5.45,1.7c10.62-.85,18.37-1.81,28.41-3.48C1326.59,1123.46,1328,1123.19,1329.48,1122.94Zm46.88-526.73c-1.13-.6-1.17-.52-.72-.3l.5.22Zm-412.56,72c-17.63-14.37-37.2-21.52-59.6-24.23-15.84-9.51-34.31-15.11-52.23-19.09-25.39-5.64-53-10.65-78.24-1.5C760.55,628.18,749,639.93,749.67,655c.51,11.37,6.34,22.26,15.92,28.13,12.57,22.39,45.18,24,69.28,22.81a12.17,12.17,0,0,0,1.47,2.28c-.48-.76-1-1.52-1.4-2.29h.21c1.54,1.73,1.87,3,1.19,2.3l.44.7.13-.14c0,.05,0,.1,0,.15l-.1.1.07.11-.22.14c-.14.1-.29.19-.44.28l0,0-.09.08c-1.07.68-2.17,1.34-3.29,2s-2.32,1.24-3.51,1.81c-13,4.91-26.89,8-40.45,11.07q-22.86,5.16-46.07,8.46c-11.22,1.36-22.47,2.22-33.72,3.38-7.23.74-14.47,1.63-21.67,2.6-3.87.52-8.33.85-12.1,2-4.72,1.42-9.32,4-13.86,6-8.79,3.87-13.3,15-13.15,24.19-5.18-.21-10.36-.56-15.51-1.11-3.06-.33-13.5-1.35-13.75-1.4-3-.53-6-1.2-9.09-1.73-2.37-.42-4.8-.66-7.2-.94a9.54,9.54,0,0,0-1.93-.42,70.24,70.24,0,0,0-11.33-.84,33.8,33.8,0,0,0-6.92.66l-1,.19-1.07.12c-6.84.8-15.19,7.32-11.78,15.46,2.23,5.3,4.1,9.92,8,14.27a65.49,65.49,0,0,0,13.57,11.14c8.62,5.57,19.56,8.92,29.39,11.82,10.76,3.18,22.42,4.3,33.5,5.59,9.58,1.11,19.2,1.79,28.83,2.25,7.56.37,15.13.51,22.72.46a49.27,49.27,0,0,0,5.25,2.31c4.18,1.66,8.33,3.55,12.61,5,10.23,3.35,20.88,4.79,31.54,5.92a309.26,309.26,0,0,0,55.36.53,361.79,361.79,0,0,0,113.43-27.46c18.22-7.69,36.34-17.55,49.05-33.14,15.49-19,22.9-40.74,19.3-65.21C988.78,696.64,977.67,679.52,963.8,668.23Zm-127,40.71c-.2.24-.36.43-.49.6l.56-.49Zm47.38,450.62c-3.35-1-6.64-2.2-9.94-3.36-1.5-.53-3-1.06-4.48-1.63.1,0-3.34-1.37-3.35-1.35-6.25-2.75-12.32-5.9-18.28-9.21-6.15-3.41-24.4-13.92-27.44-15.66-6.48-3.71-11.87-5.42-19.4-3.61-8.7,2.09-14.73,12.46-11.95,21,2.25,7,6.39,11.08,12.67,14.52l10.06,5.53c6.45,3.54,12.93,7,19.56,10.18,2.1,1,4.21,2,6.33,3l-4.5,2.35c-12.92,6.81-27.19,12.58-37.36,23.26a12.3,12.3,0,0,0-2.54,13.39c1.77,4,6.41,8.15,11.21,7.54,3.89-.5,7.66-.66,11.38-2a113.54,113.54,0,0,0,12.24-5.21l19.89-9.58c13.26-6.38,26.4-13.1,39.83-19.1,5.9-2.63,8.66-10.59,7.87-16.42A16.6,16.6,0,0,0,884.16,1159.56Zm232.29-500.08c-17.77,0-32-10.19-43.3-10.19a15.19,15.19,0,0,0-4.47.63c-5.89,2.16-10.54,8.47-10.26,14.63.4,8.85,6.77,14.72,15.38,15.38,14.92,1.13,29.88,1.67,44.85,1.54,13-.11,28.29.88,40.8-3.36,30.8-10.44,31.76-53.14,12.76-74.76-5.48-6.25-16.14-5.61-21.75,0a14.79,14.79,0,0,0-3.91,6.73,13.7,13.7,0,0,0-.78,4.66c0,8,5.93,16.35,5.93,24.46C1151.7,651.38,1128.91,659.48,1116.45,659.48Z"
            />
          </g>
          <g id="lineart">
            <path
              class={cls7}
              d="M531.65,24.7a23,23,0,0,1-3.56-6.87,26,26,0,0,1-1.29-8.25,14.52,14.52,0,0,1,1.29-6.77A4.79,4.79,0,0,1,531.65.06a8.08,8.08,0,0,1,5.18,1.33A17.58,17.58,0,0,1,542,6a23.32,23.32,0,0,1,3.57,6.87,26.29,26.29,0,0,1,1.28,8.25,14.66,14.66,0,0,1-1.28,6.77A4.82,4.82,0,0,1,542,30.68a8.08,8.08,0,0,1-5.18-1.33A17.58,17.58,0,0,1,531.65,24.7Zm8.54-.83c.82-.94,1.22-2.89,1.22-5.85a18.37,18.37,0,0,0-1.22-7.27,8.24,8.24,0,0,0-3.36-4.07c-1.4-.81-2.51-.74-3.33.2s-1.22,2.91-1.22,5.87A18.5,18.5,0,0,0,533.5,20a8.26,8.26,0,0,0,3.33,4Q539,25.29,540.19,23.87Z"
            />
            <polygon
              class={cls8}
              points="558.33 14.27 558.33 41.3 552.92 38.17 552.92 16.16 548.24 13.46 548.24 8.44 558.33 14.27"
            />
            <path
              class={cls9}
              d="M567.26,45.26a23.36,23.36,0,0,1-3.56-6.86,26.12,26.12,0,0,1-1.29-8.26,14.55,14.55,0,0,1,1.29-6.77,4.82,4.82,0,0,1,3.56-2.75A8.16,8.16,0,0,1,572.45,22a17.74,17.74,0,0,1,5.18,4.66,23.12,23.12,0,0,1,3.56,6.86,26.12,26.12,0,0,1,1.29,8.26,14.5,14.5,0,0,1-1.29,6.76,4.8,4.8,0,0,1-3.56,2.75,8,8,0,0,1-5.18-1.33A17.74,17.74,0,0,1,567.26,45.26Zm8.55-.82Q577,43,577,38.58a18.55,18.55,0,0,0-1.22-7.27,8.35,8.35,0,0,0-3.36-4.07q-2.12-1.21-3.33.21c-.82.94-1.22,2.9-1.22,5.86a18.4,18.4,0,0,0,1.22,7.27,8.17,8.17,0,0,0,3.33,4Q574.58,45.85,575.81,44.44Z"
            />
            <polygon
              class={cls7}
              points="593.95 34.83 593.95 61.86 588.53 58.73 588.53 36.72 583.85 34.02 583.85 29 593.95 34.83"
            />
            <path
              class={cls7}
              d="M602.88,65.82A22.89,22.89,0,0,1,599.32,59,26.12,26.12,0,0,1,598,50.7a14.47,14.47,0,0,1,1.29-6.76,4.8,4.8,0,0,1,3.56-2.76,8.1,8.1,0,0,1,5.18,1.34,17.58,17.58,0,0,1,5.18,4.65A23.14,23.14,0,0,1,616.81,54a26.4,26.4,0,0,1,1.28,8.26,14.69,14.69,0,0,1-1.28,6.77,4.84,4.84,0,0,1-3.57,2.75,8.1,8.1,0,0,1-5.18-1.34A17.58,17.58,0,0,1,602.88,65.82Zm8.54-.82c.82-1,1.22-2.9,1.22-5.86a18.4,18.4,0,0,0-1.22-7.27,8.17,8.17,0,0,0-3.36-4.06c-1.4-.81-2.51-.75-3.33.2s-1.22,2.9-1.22,5.86a18.58,18.58,0,0,0,1.22,7.27,8.28,8.28,0,0,0,3.33,4Q610.21,66.43,611.42,65Z"
            />
            <path
              class={cls10}
              d="M593,143.8c0,29.51-20.71,65.4-46.27,80.17,0,0-141,81.28-142.75,82.1a47.4,47.4,0,0,1-15,4.4,29,29,0,0,1-17.13-3l-.31-.14c-7.47-4.15-12.81-12-15-22.94a62.23,62.23,0,0,1-1.16-12.27c0-34.46,24.18-76.38,54-93.61,2-1.13,3.93-2.12,5.86-3,4.2-40.78,32.54-86.81,66.9-106.64a70,70,0,0,1,20.09-8.07c9.84-2.16,18.71-1.2,26.06,2.5l.67.37c12.72,6.81,20.62,22.14,20.62,44.13,0,2.44-.13,4.91-.29,7.38,0,.21,0,.4-.06.59a.1.1,0,0,0,.09,0C573.69,103.13,593,115.26,593,143.8Z"
            />
            <path
              class={cls11}
              d="M485.5,40.32l42.76,22.94c-7.35-3.7-16.22-4.66-26.06-2.5a70,70,0,0,0-20.09,8.07c-34.36,19.83-62.7,65.86-66.9,106.64-1.93.89-3.88,1.88-5.86,3-29.84,17.23-54,59.15-54,93.61a62.23,62.23,0,0,0,1.16,12.27c2.23,10.95,7.57,18.79,15,22.94l-43.24-23.23c-10.2-5.46-16.52-17.73-16.52-35.36a82,82,0,0,1,.79-11.29c2.11-15.19,8.24-31.08,17-45.24,9.58-15.57,22.32-29,36.27-37.07,2-1.14,3.92-2.14,5.85-3,4.19-40.78,32.53-86.81,66.87-106.63,18.22-10.53,34.72-11.73,46.85-5.22Z"
            />
            <path
              class={cls12}
              d="M528.26,63.26l.67.37c12.72,6.81,20.62,22.14,20.62,44.13,0,2.44-.13,4.91-.29,7.38,0,.21,0,.4-.06.59a.1.1,0,0,0,.09,0c24.4-12.56,43.75-.43,43.75,28.11,0,29.51-20.71,65.4-46.27,80.17,0,0-141,81.28-142.75,82.1a47.4,47.4,0,0,1-15,4.4,29,29,0,0,1-17.13-3l-.31-.14"
            />
            <path
              class={cls12}
              d="M528.26,63.26c-7.35-3.7-16.22-4.66-26.06-2.5a70,70,0,0,0-20.09,8.07c-34.36,19.83-62.7,65.86-66.9,106.64-1.93.89-3.88,1.88-5.86,3-29.84,17.23-54,59.15-54,93.61a62.23,62.23,0,0,0,1.16,12.27c2.23,10.95,7.57,18.79,15,22.94l-43.24-23.23c-10.2-5.46-16.52-17.73-16.52-35.36a82,82,0,0,1,.79-11.29c2.11-15.19,8.24-31.08,17-45.24,9.58-15.57,22.32-29,36.27-37.07,2-1.14,3.92-2.14,5.85-3,4.19-40.78,32.53-86.81,66.87-106.63,18.22-10.53,34.72-11.73,46.85-5.22Z"
            />
            <path
              class={cls7}
              d="M1178.09,623.41l1.5,9.55-11.82,2.87-3.44,8.76,8.5,5.53-8.5,8.23-12.48-1.69-11.71,5.92,1.24,7.36-15.26,3.78-8.37-5.6-15.5.81-6.49,6.38-16.19-2.12-1.07-7.37-13.36-4.6-11.75,2.95-10.94-7.2,6.64-6.34-6.12-8.25-12.53-1.59-1.5-9.55,6.77-1.65h.06l5-1.22,3.44-8.75-8.5-5.53,8.5-8.24,12.48,1.7,11.71-5.92-1.25-7.37,15.26-3.78,8.38,5.6,15.5-.8,6.48-6.38L1129,591l1.08,7.37,13.35,4.6,11.75-3,10.94,7.21-6.64,6.34,6.13,8.24.49.07h0Zm-35.91,13.66c4.76-12.08-8.36-24.11-29.29-26.85s-41.78,4.82-46.55,16.9a13.65,13.65,0,0,0,1.64,13,22,22,0,0,0,4.56,4.91c5.35,4.37,13.39,7.65,23.12,8.93,15.78,2.07,31.51-1.73,40.33-8.92a21.69,21.69,0,0,0,4.56-4.92A16,16,0,0,0,1142.18,637.07Z"
            />
            <path
              class={cls10}
              d="M291.41,536.68v23.54a17.71,17.71,0,0,1-8.85,15.33L68.25,699.28c-2.13,1.23-4.08,1.3-5.57.41-1.76-1-2.87-3.41-2.87-6.79V670.4Z"
            />
            <path
              class={cls10}
              d="M291.41,373.09V536.68L59.81,670.4V506.82c0-6.23,3.77-13.45,8.44-16.15L283,366.71c2.05-1.19,3.94-1.3,5.41-.51l.15.09C290.29,367.33,291.41,369.71,291.41,373.09Z"
            />
            <path
              class={cls7}
              d="M269.14,354.82l19.23,11.38c-1.47-.79-3.36-.68-5.41.51l-214.71,124c-4.67,2.7-8.44,9.92-8.44,16.15V692.9c0,3.38,1.11,5.76,2.87,6.79h0L43.3,688.23c-1.77-1-2.88-3.42-2.88-6.8V495.34c0-6.22,3.78-13.44,8.44-16.13l214.71-124C265.71,354,267.66,353.94,269.14,354.82Z"
            />
            <path
              class={cls11}
              d="M213.32,624.76c24.76,14.29,24.76,37.47,0,51.76-12.38,7.15-28.61,10.72-44.82,10.72s-32.45-3.57-44.83-10.72a52.64,52.64,0,0,1-7.29-5l22.31-12.87a23.46,23.46,0,0,0,6.58,5.43c6.42,3.7,14.82,5.55,23.23,5.55s16.8-1.85,23.22-5.55c8.86-5.12,11.6-12.44,8.22-18.9l-8.8-16.82,13.48-7.78A70,70,0,0,1,213.32,624.76Z"
            />
            <path
              class={cls7}
              d="M199.94,645.15c3.38,6.46.64,13.78-8.22,18.9-6.42,3.7-14.82,5.55-23.22,5.55s-16.81-1.85-23.23-5.55a23.46,23.46,0,0,1-6.58-5.43l52.45-30.29Z"
            />
            <path
              class={cls12}
              d="M288.37,366.2c-1.47-.79-3.36-.68-5.41.51l-214.71,124c-4.67,2.7-8.44,9.92-8.44,16.15V692.9c0,3.38,1.11,5.75,2.87,6.79,1.5.88,3.44.82,5.57-.41L282.56,575.55a17.71,17.71,0,0,0,8.85-15.33V373.09c0-3.38-1.12-5.76-2.89-6.8"
            />
            <line class={cls12} x1="291.41" y1="536.68" x2="59.81" y2="670.4" />
            <path
              class={cls12}
              d="M62.68,699.7,43.3,688.23c-1.77-1-2.88-3.42-2.88-6.8V495.34c0-6.22,3.78-13.44,8.44-16.13l214.71-124c2.14-1.22,4.09-1.3,5.57-.42l19.38,11.47"
            />
            <path
              class={cls12}
              d="M191.14,628.33l8.8,16.82c3.38,6.46.64,13.78-8.22,18.9-6.42,3.7-14.82,5.55-23.22,5.55s-16.81-1.85-23.23-5.55a23.46,23.46,0,0,1-6.58-5.43"
            />
            <path
              class={cls12}
              d="M116.38,671.49a52.64,52.64,0,0,0,7.29,5c12.38,7.15,28.6,10.72,44.83,10.72s32.44-3.57,44.82-10.72c24.76-14.29,24.76-37.47,0-51.76a70,70,0,0,0-8.7-4.21"
            />
            <polygon
              class={cls11}
              points="1476.19 561.33 1476.19 583.14 1363.04 649.23 1362.83 626.79 1476.19 561.33"
            />
            <path
              class={cls10}
              d="M1476.19,561.33l-113.36,65.46c-31.79-27.13-52.8-39-94.45-54.55l113.35-65.45C1419.25,520.3,1444.25,534.39,1476.19,561.33Z"
            />
            <path
              class={cls10}
              d="M1294,441.26l-112.26,65.47c5,2.59,9.68,5.09,14.11,7.56,25,14,42,27.17,61.23,46.33,38.76-20.56,77.37-41.33,115.09-63.44C1343.55,469.23,1323.37,456.94,1294,441.26Z"
            />
            <path
              class={cls11}
              d="M1372.16,497.18c-37.72,22.11-76.33,42.88-115.09,63.44,3.67,3.64,7.41,7.5,11.31,11.62l113.35-65.45C1378.43,503.39,1375.25,500.2,1372.16,497.18Z"
            />
            <path
              class={cls11}
              d="M1362.83,626.79l.21,22.44-33.56-19.91,6.17-6.63-18-10.36-5.71,6.56-43.24-25.65-.51-20.72.2-.28C1310,587.81,1331,599.66,1362.83,626.79Z"
            />
            <polygon
              class={cls7}
              points="1335.65 622.69 1306.4 654.17 1301.89 644.73 1287.93 646.52 1317.64 612.33 1335.65 622.69"
            />
            <path
              class={cls12}
              d="M1476.19,561.33c-31.94-26.94-56.94-41-94.46-54.54-33.93-35-55.2-48.15-87.74-65.53l-112.26,65.47c5,2.59,9.68,5.09,14.11,7.56,29.75,16.67,48.13,32.14,72.54,58,41.65,15.57,62.66,27.42,94.45,54.55Z"
            />
            <path
              class={cls12}
              d="M1372.2,583.83A256.3,256.3,0,0,0,1335,564.19"
            />
            <path
              class={cls12}
              d="M1393.53,571.51a255.38,255.38,0,0,0-37.2-19.64"
            />
            <path
              class={cls12}
              d="M1414.86,559.2a255.38,255.38,0,0,0-37.2-19.64"
            />
            <polyline
              class={cls12}
              points="1268.18 572.52 1268.69 593.25 1311.93 618.89"
            />
            <polyline
              class={cls12}
              points="1329.48 629.32 1363.04 649.23 1362.83 626.79"
            />
            <polyline
              class={cls12}
              points="1476.19 561.33 1476.19 583.14 1363.04 649.23"
            />
            <line
              class={cls12}
              x1="1268.38"
              y1="572.24"
              x2="1381.73"
              y2="506.79"
            />
            <polygon
              class={cls12}
              points="1311.93 618.89 1317.64 612.33 1335.65 622.69 1306.4 654.17 1301.89 644.73 1287.93 646.52 1311.93 618.89"
            />
            <path
              class={cls11}
              d="M831.6,379.07a9.65,9.65,0,0,1-6,9.27,383.38,383.38,0,0,1-83.21,23.41,9.27,9.27,0,0,1-1.58.13,9.58,9.58,0,0,1-3.69-.75,15,15,0,0,0,1,10c0,2.15,3.22,5.37,6.44,5.37,31.1-4.29,59-20.38,90.1-22.53,8.58,0,17.16-7.51,11.8-16.09C842.86,382.13,837.44,379.69,831.6,379.07Z"
            />
            <path
              class={cls11}
              d="M948.41,356.76a49.23,49.23,0,0,1,12.28-11.69c0-.84-.06-1.67-.11-2.51,2.13-3.7,4-7.15,5.8-10.44.55-1,1.1-2.1,1.61-3.16q-15.22,12.78-29.83,23.67c-1.65,1.23-3,1.71-4,1.55a12.61,12.61,0,0,0,.32,1.5C936.61,364.26,945.19,361.05,948.41,356.76Z"
            />
            <path
              class={cls10}
              d="M948.41,356.76c-3.22,4.29-11.8,7.5-13.95-1.08a12.61,12.61,0,0,1-.32-1.5c-2-.33-2.6-3.22-1.26-8.06,2-7.27,7.67-16.14,12.6-19.81q14.58-10.86,29.84-23.77c.2-1.94.31-3.91.35-5.87.36-18.74,17.65-145.52-109.2-216.85h0c-24.28-7.7-53.84-4.06-81.4,6.88-30.24,12-78.85,41.58-118.65,77.93C638.61,190,615.12,218.69,605.16,247c28.34,31.34,46.53,75.43,44.37,114.6-.72,13-3.61,24.36-8.28,33.73-8.55,17.2-23,27.83-40.81,30.4v0c-18.37,73,30.8,138.29,83.59,183.65,44.13,37.92,90.77,62,102.64,65,.37.1.72.17,1,.23,22.31,4.07,42,1,59.31-7.25l2.11-1c58.1-29.6,89.07-118.79,102.9-194.47a560.78,560.78,0,0,0,8.68-126.87A49.23,49.23,0,0,0,948.41,356.76ZM820.17,466.62c-6,3.47-11.93,1-13.37-5.57S809,446.38,815,442.9s11.92-1,13.35,5.57S826.11,463.14,820.17,466.62ZM834.71,404c-31.11,2.15-59,18.24-90.1,22.53-3.22,0-6.44-3.22-6.44-5.37a15,15,0,0,1-1-10,9.65,9.65,0,0,1,2.14-18.43,363.81,363.81,0,0,0,79-22.22,9.63,9.63,0,0,1,13.3,8.59c5.84.62,11.26,3.06,14.91,8.79C851.87,396.44,843.29,404,834.71,404Zm113.86-12.19c-.49,6.48-5.16,13.46-10.41,15.58s-9.12-1.4-8.63-7.88S934.69,386,940,383.88,949.06,385.28,948.57,391.76Z"
            />
            <path
              class={cls6}
              d="M959.94,409.2a50.12,50.12,0,0,1-14.5,13.13c-7.18,4.2-14.38,5.58-20.75,4.51.47-4.87.85-9.62,1.08-14.22A63.67,63.67,0,0,1,937,379.8c10.7-15.59,17.95-27.33,23.62-37.24A552.89,552.89,0,0,1,959.94,409.2Z"
            />
            <ellipse
              class={cls6}
              cx="817.57"
              cy="454.76"
              rx="43.65"
              ry="31.7"
              transform="translate(49.65 989.1) rotate(-63.92)"
            />
            <path
              class={cls10}
              d="M975.32,302.54A77.58,77.58,0,0,1,968,329q-15.22,12.78-29.83,23.67c-4.94,3.68-7.3.76-5.28-6.51s7.67-16.14,12.6-19.81Q960.06,315.45,975.32,302.54Z"
            />
            <path
              class={cls7}
              d="M940,383.88c5.25-2.13,9.11,1.4,8.62,7.88s-5.16,13.46-10.41,15.58-9.12-1.4-8.63-7.88S934.69,386,940,383.88Z"
            />
            <path
              class={cls7}
              d="M849.11,694.06v.49c0,26.37-17.42,52.71-52.26,72.83-69.68,40.23-182.64,40.23-252.32,0-34.84-20.11-52.25-46.47-52.25-72.83V651.64c0,26.36,17.41,52.73,52.25,72.84,69.68,40.22,182.64,40.22,252.32,0,27.85-16.08,44.56-36.16,50.15-57l2.11-1Z"
            />
            <path
              class={cls10}
              d="M847,667.45c-5.59,20.87-22.3,40.95-50.15,57-69.68,40.22-182.64,40.22-252.32,0-34.84-20.11-52.25-46.48-52.25-72.84s17.41-52.72,52.25-72.84q7.43-4.27,15.45-7.94a193.57,193.57,0,0,1-13.59,34.37c-.72,1.42-1.45,2.84-2.19,4.24A54.23,54.23,0,0,0,538.93,625a53.18,53.18,0,0,0,10.69,42.58c6.43,8,15.37,15.49,26.79,22.08,52.4,30.25,137.35,30.25,189.74,0a103.77,103.77,0,0,0,20.52-15.21c.37.1.72.17,1,.23C810,678.73,829.68,675.74,847,667.45Z"
            />
            <path
              class={cls10}
              d="M830.89,375.74a9.66,9.66,0,0,1-5.26,12.6,382.26,382.26,0,0,1-83.21,23.41,9.27,9.27,0,0,1-1.58.13,9.65,9.65,0,0,1-1.55-19.18,363.81,363.81,0,0,0,79-22.22A9.64,9.64,0,0,1,830.89,375.74Z"
            />
            <path
              class={cls7}
              d="M828.34,448.47c1.43,6.55-2.23,14.67-8.17,18.15s-11.93,1-13.37-5.57S809,446.38,815,442.9,826.91,441.93,828.34,448.47Z"
            />
            <path
              class={cls9}
              d="M756.55,694.7c3.3-1.57,6.51-3.24,9.6-5a103.77,103.77,0,0,0,20.52-15.21c-11.87-3.09-58.51-27.12-102.64-65a174.52,174.52,0,0,1-29.91.94A324.67,324.67,0,0,0,756.55,694.7Z"
            />
            <path
              class={cls11}
              d="M654.12,610.37c-22.68-1.21-44.8-6.82-62.17-16.85-16.75-9.66-26.41-21.89-29-34.49q-1.31,5.94-3,11.83a193.57,193.57,0,0,1-13.59,34.37c-.72,1.42-1.45,2.84-2.19,4.24A54.23,54.23,0,0,0,538.93,625a53.18,53.18,0,0,0,10.69,42.58c6.43,8,15.37,15.49,26.79,22.08,49.31,28.47,127.45,30.14,180.14,5A324.67,324.67,0,0,1,654.12,610.37Z"
            />
            <path
              class={cls10}
              d="M598.29,478.64a128.64,128.64,0,0,1,2.15-52.86v0c-11.39,1.66-24.14,0-37.56-5.34h0c-8.46-1.9-17.46-6.32-26.56-13.41-.92-.72-1.84-1.47-2.75-2.23q2.54,4.56,5.26,9.07A198.28,198.28,0,0,1,563,559c2.55,12.6,12.21,24.83,29,34.49,17.37,10,39.49,15.64,62.17,16.85-22.9-28.66-40.58-61.15-51.1-95.94A104.67,104.67,0,0,1,598.29,478.64Z"
            />
            <path
              class={cls11}
              d="M684,609.43c-39.66-34.08-77.28-79.39-85.74-130.79A104.67,104.67,0,0,0,603,514.43c10.52,34.79,28.2,67.28,51.1,95.94A174.52,174.52,0,0,0,684,609.43Z"
            />
            <path
              class={cls9}
              d="M605.16,247c28.34,31.34,46.53,75.43,44.37,114.6-.72,13-3.61,24.36-8.28,33.73l-54.4,23.15c13.32-5.94,23-20.55,26.1-42.59,6.31-45.25-17.78-104.69-53.82-132.77C541,229,523.37,225.53,509.47,231.26l46.26-19.69a101,101,0,0,1,9.65,4.3C579.9,223.22,593.4,234,605.16,247Z"
            />
            <path
              class={cls7}
              d="M586.85,418.51l54.4-23.15c-8.55,17.2-23,27.83-40.81,30.4-11.39,1.66-24.14,0-37.56-5.34,8.5,1.91,16.46,1.29,23.44-1.68Z"
            />
            <path
              class={cls10}
              d="M559.13,243.15c36,28.08,60.13,87.52,53.82,132.77-3.06,22-12.78,36.65-26.1,42.59l-.53.23c-7,3-14.94,3.59-23.44,1.68h0c-8.46-1.9-17.46-6.32-26.56-13.41-.92-.72-1.84-1.47-2.75-2.23-34.51-28.91-57.22-86.46-51.08-130.55,2.61-18.7,10-32,20.3-39.28a35.53,35.53,0,0,1,6.34-3.53l.36-.15C523.37,225.53,541,229,559.13,243.15Zm27.66,116c4.09-29.34-11.53-67.88-34.89-86.08s-45.61-9.19-49.69,20.14,11.53,67.88,34.89,86.08S582.71,388.44,586.79,359.11Z"
            />
            <path
              class={cls3}
              d="M753.46,41.28c-69.15-12.65-136.18,14.09-184,63.08a248,248,0,0,0-60.79,105c13.54-4.89,29.73-4.42,47.09,2.25a101,101,0,0,1,9.65,4.3c14.52,7.35,28,18.16,39.78,31.16,10-28.34,33.45-57,61.24-82.41,39.8-36.35,88.41-65.93,118.65-77.93,27.56-10.94,57.12-14.58,81.4-6.88C837.15,63.33,800.14,49.81,753.46,41.28Z"
            />
            <path
              class={cls7}
              d="M551.9,273c23.36,18.2,39,56.74,34.89,86.08s-26.33,38.36-49.69,20.14-39-56.74-34.89-86.08S528.54,254.82,551.9,273Zm8.53,68.87c2-14-5.52-32.44-16.68-41.15s-21.81-4.39-23.76,9.63,5.51,32.46,16.68,41.16S558.48,355.93,560.43,341.9Z"
            />
            <path
              class={cls8}
              d="M543.75,300.75c11.16,8.71,18.63,27.13,16.68,41.15s-12.59,18.35-23.76,9.64S518,324.41,520,310.38,532.58,292.05,543.75,300.75Z"
            />
            <path
              class={cls7}
              d="M555.73,211.57l-46.62,19.84a35.53,35.53,0,0,0-6.34,3.53,244.26,244.26,0,0,1,5.87-25.62C522.18,204.43,538.37,204.9,555.73,211.57Z"
            />
            <path
              class={cls12}
              d="M960.58,342.56A559.93,559.93,0,0,1,952,471.94c-13.83,75.68-44.78,164.91-102.9,194.47l-2.11,1c-17.3,8.33-37,11.28-59.31,7.25-.3-.06-.65-.13-1-.23-11.87-3.07-58.52-27.12-102.64-65-52.79-45.36-102-110.61-83.59-183.65"
            />
            <path
              class={cls12}
              d="M508.63,209.32h0c13.54-4.89,29.73-4.42,47.09,2.25a101,101,0,0,1,9.65,4.3c14.52,7.35,28,18.16,39.78,31.16,28.34,31.34,46.53,75.43,44.37,114.6-.72,13-3.62,24.36-8.28,33.73-8.55,17.2-23,27.82-40.81,30.4-11.4,1.66-24.14,0-37.56-5.34"
            />
            <path
              class={cls12}
              d="M866.45,79.81c-29.3-16.48-66.31-30-113-38.53-69.15-12.65-136.18,14.09-184,63.08a248.27,248.27,0,0,0-66.66,130.58"
            />
            <path
              class={cls12}
              d="M866.32,512.8c1.12,8.82,5.24,11.05,10.44,11.05s11.75-2.31,17.26-2.31c6,0,9.31,6.22,19.6,6.22,3.44,0,7.11-2.16,10.28-4.74a11.68,11.68,0,0,0,1.74-16.33c-.84-1-1.72-2.14-2.63-3.34a20.49,20.49,0,0,1-4.22-12.82c.63-26.75,5.82-54.39,7-77.91A63.67,63.67,0,0,1,937,379.8c10.7-15.58,17.94-27.33,23.62-37.24,2.13-3.71,4-7.15,5.8-10.44.55-1,1.1-2.1,1.61-3.16a78.79,78.79,0,0,0,7.33-26.42c.19-1.94.31-3.91.35-5.87.36-18.74,17.65-145.52-109.2-216.85"
            />
            <path
              class={cls12}
              d="M586.32,418.74c-7,3-14.94,3.59-23.44,1.68h0c-8.46-1.9-17.46-6.32-26.56-13.41-.92-.72-1.84-1.47-2.75-2.23-34.53-28.88-57.22-86.46-51.08-130.55,2.61-18.7,10-32,20.3-39.28a34.92,34.92,0,0,1,6.34-3.53"
            />
            <path
              class={cls12}
              d="M509.47,231.26c13.9-5.73,31.56-2.22,49.66,11.89,36,28.08,60.13,87.52,53.82,132.77-3.06,22-12.78,36.65-26.1,42.59"
            />
            <path
              class={cls12}
              d="M586.79,359.11c-4.08,29.33-26.33,38.36-49.69,20.14s-39-56.74-34.89-86.08S528.54,254.82,551.9,273,590.88,329.77,586.79,359.11Z"
            />
            <path
              class={cls12}
              d="M560.43,341.9c-1.95,14-12.59,18.35-23.76,9.64S518,324.41,520,310.38s12.59-18.33,23.76-9.63S562.38,327.88,560.43,341.9Z"
            />
            <line
              class={cls12}
              x1="509.11"
              y1="231.41"
              x2="555.73"
              y2="211.57"
            />
            <polyline
              class={cls12}
              points="586.32 418.74 641.25 395.36 641.26 395.35"
            />
            <path
              class={cls12}
              d="M786.67,674.47a103.77,103.77,0,0,1-20.52,15.21c-52.39,30.25-137.34,30.25-189.74,0-11.42-6.59-20.36-14.09-26.79-22.08A53.18,53.18,0,0,1,538.93,625a54.23,54.23,0,0,1,5.27-15.55c.74-1.4,1.47-2.82,2.19-4.24A194.34,194.34,0,0,0,560,570.86q1.69-5.9,3-11.83a198.55,198.55,0,0,0-24.18-145.19q-2.73-4.51-5.26-9.07"
            />
            <path
              class={cls12}
              d="M560,570.86q-8,3.66-15.45,7.94c-34.84,20.12-52.25,46.48-52.25,72.84s17.41,52.73,52.25,72.84c69.68,40.22,182.64,40.22,252.32,0,27.85-16.08,44.56-36.16,50.15-57"
            />
            <line
              class={cls12}
              x1="849.11"
              y1="666.41"
              x2="849.11"
              y2="694.06"
            />
            <path
              class={cls12}
              d="M492.28,651.64v42.91c0,26.36,17.41,52.72,52.25,72.83,69.68,40.23,182.64,40.23,252.32,0,34.84-20.12,52.26-46.46,52.26-72.83v-.49"
            />
            <path
              class={cls12}
              d="M740.84,411.88a9.65,9.65,0,0,1-1.55-19.18,363.81,363.81,0,0,0,79-22.22,9.65,9.65,0,0,1,7.33,17.86,382.26,382.26,0,0,1-83.21,23.41A9.27,9.27,0,0,1,740.84,411.88Z"
            />
            <path
              class={cls12}
              d="M975.33,302.53h0q-15.26,12.9-29.84,23.77c-4.93,3.67-10.57,12.54-12.6,19.81s.34,10.19,5.28,6.51Q952.73,341.77,968,329l0,0"
            />
            <path
              class={cls12}
              d="M828.34,448.47c1.43,6.55-2.23,14.67-8.17,18.15s-11.93,1-13.37-5.57S809,446.38,815,442.9,826.91,441.93,828.34,448.47Z"
            />
            <path
              class={cls12}
              d="M929.53,399.46c-.49,6.48,3.37,10,8.63,7.88s9.92-9.1,10.41-15.58-3.37-10-8.62-7.88S930,393,929.53,399.46Z"
            />
            <path
              class={cls12}
              d="M831.24,382.09c14.4-2.09,23.8.91,33.52,12.45"
            />
            <path
              class={cls12}
              d="M605.16,247c10-28.34,33.45-57,61.24-82.41,39.8-36.35,88.41-65.93,118.65-77.93,27.56-10.94,57.12-14.58,81.4-6.88h0"
            />
            <path
              class={cls12}
              d="M684,609.43C651.81,613.26,617,608,592,593.52c-16.75-9.66-26.41-21.89-29-34.49v0"
            />
            <polygon
              class={cls11}
              points="1336.23 1073.09 1336.23 1101.6 1255.17 1148.39 1255.17 1119.89 1336.23 1073.09"
            />
            <polygon
              class={cls10}
              points="1336.23 1073.09 1255.17 1119.89 1230.47 1105.64 1311.54 1058.84 1336.23 1073.09"
            />
            <polygon
              class={cls11}
              points="1311.54 1030.32 1311.54 1058.84 1230.47 1105.64 1230.47 1077.13 1311.54 1030.32"
            />
            <polygon
              class={cls10}
              points="1311.54 1030.32 1230.47 1077.13 1205.78 1062.87 1286.85 1016.07 1311.54 1030.32"
            />
            <polygon
              class={cls7}
              points="1309.7 845.56 1309.7 974.27 1286.78 987.51 1211.66 944.14 1130.61 990.95 1130.61 1076.49 1131.63 1077.08 1031.01 1135.18 1031.01 1006.46 1309.7 845.56"
            />
            <path
              class={cls10}
              d="M1309.7,845.56,1031,1006.46,873.08,915.29l278.7-160.91Zm-137-6.43-15.8-40.52L1102.51,830Zm-98.23,52.6,40.37-23.31-40.37-23.3-40.38,23.3Zm-48.58,33.34c12.8-7.39,12.8-19.37,0-26.76s-33.56-7.39-46.35,0-12.81,19.37,0,26.76S1013.11,932.46,1025.91,925.07Z"
            />
            <polygon
              class={cls11}
              points="1286.85 987.55 1286.85 1016.07 1205.78 1062.87 1205.78 1034.35 1286.85 987.55"
            />
            <polygon
              class={cls10}
              points="1286.78 987.51 1286.85 987.55 1205.78 1034.35 1130.61 990.95 1211.66 944.14 1286.78 987.51"
            />
            <polygon
              class={cls10}
              points="1255.17 1119.89 1255.17 1148.39 1130.61 1076.49 1130.61 990.95 1205.78 1034.35 1205.78 1062.87 1230.47 1077.13 1230.47 1105.64 1255.17 1119.89"
            />
            <polygon
              class={cls7}
              points="1156.92 798.61 1172.72 839.13 1102.51 830.01 1156.92 798.61"
            />
            <polygon
              class={cls7}
              points="1114.86 868.42 1074.48 891.73 1034.11 868.42 1074.48 845.12 1114.86 868.42"
            />
            <polygon
              class={cls10}
              points="1031.01 1006.46 1031.01 1135.18 873.08 1044 873.08 915.29 1031.01 1006.46"
            />
            <ellipse
              class={cls7}
              cx="1002.73"
              cy="911.69"
              rx="32.78"
              ry="18.92"
            />
            <polygon
              class={cls12}
              points="1230.47 1105.64 1230.47 1077.13 1205.78 1062.87 1205.78 1034.35 1130.61 990.95 1130.61 1076.49 1255.17 1148.39 1255.17 1119.89 1230.47 1105.64"
            />
            <polyline
              class={cls12}
              points="1130.61 990.95 1211.66 944.14 1286.85 987.55 1286.85 1016.07 1311.54 1030.32 1311.54 1058.84 1336.23 1073.09 1336.23 1101.6 1255.17 1148.39"
            />
            <line
              class={cls12}
              x1="1205.78"
              y1="1034.35"
              x2="1286.85"
              y2="987.55"
            />
            <line
              class={cls12}
              x1="1230.47"
              y1="1077.13"
              x2="1311.54"
              y2="1030.32"
            />
            <line
              class={cls12}
              x1="1255.17"
              y1="1119.89"
              x2="1336.23"
              y2="1073.09"
            />
            <line
              class={cls12}
              x1="1230.47"
              y1="1105.64"
              x2="1311.54"
              y2="1058.84"
            />
            <line
              class={cls12}
              x1="1205.78"
              y1="1062.87"
              x2="1286.85"
              y2="1016.07"
            />
            <polygon
              class={cls12}
              points="873.08 915.29 1151.78 754.38 1309.7 845.56 1031.01 1006.46 873.08 915.29"
            />
            <line
              class={cls12}
              x1="1031.01"
              y1="1006.46"
              x2="1031.01"
              y2="1135.18"
            />
            <polyline
              class={cls12}
              points="873.08 915.29 873.08 1044 1031.01 1135.18 1131.63 1077.08"
            />
            <polyline
              class={cls12}
              points="1286.77 987.52 1286.78 987.51 1309.7 974.27 1309.7 845.56"
            />
            <ellipse
              class={cls12}
              cx="1002.73"
              cy="911.69"
              rx="32.77"
              ry="18.92"
            />
            <polygon
              class={cls12}
              points="1034.11 868.42 1074.48 845.12 1114.86 868.42 1074.48 891.73 1034.11 868.42"
            />
            <polygon
              class={cls12}
              points="1156.92 798.61 1172.72 839.13 1102.51 830.01 1156.92 798.61"
            />
            <path
              class={cls8}
              d="M991.62,780.41V903.24c0,3.47-2.29,7-6.88,9.6-9.18,5.31-24.09,5.31-33.27,0-4.59-2.65-6.88-6.13-6.88-9.6v-123c0,3.45,2.29,6.91,6.88,9.6,9.18,5.3,24.09,5.3,33.27,0C989.26,787.24,991.57,783.82,991.62,780.41Z"
            />
            <path
              class={cls10}
              d="M991.62,780.27v.14c0,3.41-2.36,6.83-6.88,9.46-9.18,5.3-24.09,5.3-33.27,0-4.59-2.69-6.88-6.15-6.88-9.6s2.29-7,6.88-9.64c9.18-5.29,24.09-5.29,33.27,0C989.33,773.32,991.62,776.77,991.62,780.27Z"
            />
            <path
              class={cls12}
              d="M991.62,780.41c0,3.41-2.36,6.83-6.88,9.46-9.18,5.3-24.09,5.3-33.27,0-4.59-2.69-6.88-6.15-6.88-9.6s2.29-7,6.88-9.64c9.18-5.29,24.09-5.29,33.27,0,4.59,2.69,6.88,6.14,6.88,9.64"
            />
            <path
              class={cls12}
              d="M991.62,780.27v123c0,3.47-2.29,7-6.88,9.6-9.18,5.31-24.09,5.31-33.27,0-4.59-2.65-6.88-6.13-6.88-9.6v-123"
            />
            <path
              class={cls11}
              d="M386.41,670.34c3.91,8.28.23,17.5-11.05,24-8.38,4.84-19.34,7.26-30.3,7.26s-21.93-2.42-30.29-7.26c-11.27-6.5-14.95-15.72-11.06-24l7.91-18.48h0a11.82,11.82,0,0,0-1,4.75c0,5.11,3.32,10.18,10.06,14.07,13.46,7.77,35.27,7.77,48.7,0,6.51-3.75,9.88-8.63,10.09-13.57a12.21,12.21,0,0,0-.74-4.68Z"
            />
            <path
              class={cls10}
              d="M311.64,651.87h0l33.44-78.14,33.69,78.72a11.64,11.64,0,0,1,.74,4.68c-.21,4.94-3.58,9.82-10.09,13.57-13.43,7.77-35.24,7.77-48.7,0-6.74-3.89-10.06-9-10.06-14.07A11.82,11.82,0,0,1,311.64,651.87Z"
            />
            <path
              class={cls12}
              d="M378.5,651.86l-33.44-78.14-41.35,96.62c-3.89,8.28-.21,17.5,11.06,24,8.36,4.84,19.3,7.26,30.29,7.26s21.92-2.42,30.3-7.26c11.28-6.5,15-15.72,11.05-24l-7.66-17.9"
            />
            <path
              class={cls12}
              d="M378.5,651.86l.25.58a11.64,11.64,0,0,1,.74,4.68c-.21,4.94-3.58,9.82-10.09,13.57-13.43,7.77-35.24,7.77-48.7,0-6.74-3.89-10.06-9-10.06-14.07a11.82,11.82,0,0,1,1-4.75h0"
            />
            <polygon
              class={cls8}
              points="1238.89 214.05 1238.89 297.58 1142.24 241.78 1142.24 158.24 1238.89 214.05"
            />
            <polygon
              class={cls12}
              points="1238.89 297.58 1142.24 241.78 1142.24 158.24 1238.89 214.05 1238.89 297.58"
            />
            <path
              class={cls10}
              d="M1098,213.76c-7.41,4.27-12,13.44-12,26.49,0,17.66,8.38,37.88,20.78,53.16a75,75,0,0,0,20.16,17.77c22.62,13.06,41,2.47,41-23.64s-18.34-57.87-41-70.93C1115.61,210.08,1105.36,209.47,1098,213.76Zm91.49,14V372.21L1064.39,300V155.59Z"
            />
            <path
              class={cls11}
              d="M1126.91,216.61c22.62,13.06,41,44.82,41,70.93s-18.34,36.7-41,23.64a75,75,0,0,1-20.16-17.77l9.2-13.47h0a40.81,40.81,0,0,0,11,9.67c12.29,7.1,22.26,1.34,22.26-12.85s-10-31.45-22.26-38.54c-6.14-3.56-11.7-3.9-15.73-1.56h0L1098,213.76C1105.36,209.47,1115.61,210.08,1126.91,216.61Z"
            />
            <path
              class={cls10}
              d="M1126.91,238.21c12.29,7.09,22.26,24.34,22.26,38.54s-10,19.95-22.26,12.85a40.81,40.81,0,0,1-11-9.67c-6.75-8.3-11.29-19.29-11.29-28.89,0-7.09,2.48-12.07,6.51-14.39S1120.77,234.65,1126.91,238.21Z"
            />
            <path
              class={cls7}
              d="M1116,279.93h0l-9.2,13.47c-12.4-15.28-20.78-35.5-20.78-53.16,0-13.05,4.58-22.22,12-26.49l13.22,22.88h0c-4,2.32-6.51,7.3-6.51,14.39C1104.67,260.64,1109.21,271.63,1116,279.93Z"
            />
            <polygon
              class={cls12}
              points="1189.45 372.21 1064.39 300 1064.39 155.59 1189.45 227.79 1189.45 372.21"
            />
            <path
              class={cls12}
              d="M1106.75,293.41a75,75,0,0,0,20.16,17.77c22.62,13.06,41,2.47,41-23.64s-18.34-57.87-41-70.93c-11.3-6.53-21.54-7.13-29-2.85s-12,13.44-12,26.49C1086,257.91,1094.35,278.13,1106.75,293.41Z"
            />
            <path
              class={cls12}
              d="M1116,279.93a40.81,40.81,0,0,0,11,9.67c12.29,7.1,22.26,1.34,22.26-12.85s-10-31.45-22.26-38.54c-6.14-3.56-11.7-3.89-15.73-1.56s-6.51,7.3-6.51,14.39C1104.67,260.64,1109.22,271.62,1116,279.93Z"
            />
            <polyline
              class={cls12}
              points="1111.18 236.64 1097.96 213.76 1097.96 213.75"
            />
            <line
              class={cls12}
              x1="1115.95"
              y1="279.94"
              x2="1106.75"
              y2="293.41"
            />
            <line
              class={cls12}
              x1="1421.29"
              y1="415.52"
              x2="1456.28"
              y2="395.32"
            />
            <line
              class={cls12}
              x1="1456.28"
              y1="415.52"
              x2="1421.29"
              y2="395.32"
            />
            <line
              class={cls12}
              x1="452.71"
              y1="459.07"
              x2="487.7"
              y2="438.87"
            />
            <line
              class={cls12}
              x1="487.7"
              y1="459.07"
              x2="452.71"
              y2="438.87"
            />
            <line
              class={cls12}
              x1="987.85"
              y1="1221.75"
              x2="1022.84"
              y2="1201.54"
            />
            <line
              class={cls12}
              x1="1022.84"
              y1="1221.75"
              x2="987.85"
              y2="1201.54"
            />
            <path
              class={cls13}
              d="M1074.4,459.6a20.67,20.67,0,1,0-20.67,20.67A20.67,20.67,0,0,0,1074.4,459.6Z"
            />
            <path
              class={cls13}
              d="M210.28,259.79a20.67,20.67,0,1,0-20.67,20.67A20.67,20.67,0,0,0,210.28,259.79Z"
            />
            <path
              class={cls13}
              d="M52.61,843.68a20.68,20.68,0,1,0-20.68,20.67A20.67,20.67,0,0,0,52.61,843.68Z"
            />
            <polyline
              class={cls12}
              points="112.21 360.59 90.37 382.11 68.53 335.37 46.69 356.88 24.84 310.14 3 331.66"
            />
            <polyline
              class={cls12}
              points="1511.4 803.47 1489.56 824.99 1467.72 778.25 1445.88 799.77 1424.03 753.02 1402.19 774.54"
            />
            <path
              class={cls10}
              d="M706.15,906.19v117L490.9,1147.43c15.48-35.06,26.41-48.39,35.08-53.4,10.06-5.81,17.06-.37,24.58-4.72,29.6-17.09,13.57-84.5,55.06-108.46,27.2-15.7,25.82,45,49,31.64C675.28,1000.54,692.73,948.52,706.15,906.19Z"
            />
            <path
              class={cls12}
              d="M706.15,1023.16v-117c-13.42,42.33-30.87,94.35-51.56,106.3-23.15,13.36-21.77-47.34-49-31.64-41.49,24-25.46,91.37-55.06,108.46C543,1093.66,536,1088.22,526,1094c-8.67,5-19.6,18.34-35.08,53.4"
            />
            <path
              class={cls12}
              d="M716.81,873c-3.2,9.45-6.76,20.93-10.66,33.24"
            />
            <polyline
              class={cls12}
              points="695.87 900.27 716.81 872.95 720.44 899.13"
            />
            <path
              class={cls10}
              d="M870.77,1166.48c3.85,2.23,3.86,5.84,0,8.07a15.42,15.42,0,0,1-14,0c-3.86-2.22-3.86-5.84,0-8.07A15.45,15.45,0,0,1,870.77,1166.48Z"
            />
            <path
              class={cls10}
              d="M802.63,1205.82c3.85,2.23,3.86,5.84,0,8.07a15.42,15.42,0,0,1-14,0c-3.86-2.23-3.86-5.84,0-8.07A15.45,15.45,0,0,1,802.63,1205.82Z"
            />
            <path
              class={cls10}
              d="M856.8,1174.55l-54.17,31.27a15.45,15.45,0,0,0-14,0l-54.17-31.27c3.87-2.23,3.86-5.84,0-8.07l54.17-31.27a15.42,15.42,0,0,0,14,0l54.17,31.27C852.94,1168.71,852.94,1172.33,856.8,1174.55Zm-61.16,9.21,23-13.25-23-13.24-22.94,13.24Z"
            />
            <polygon
              class={cls7}
              points="818.59 1170.51 795.64 1183.76 772.7 1170.51 795.64 1157.27 818.59 1170.51"
            />
            <path
              class={cls10}
              d="M802.63,1127.15c3.85,2.22,3.86,5.83,0,8.06a15.42,15.42,0,0,1-14,0c-3.87-2.23-3.86-5.84,0-8.06A15.42,15.42,0,0,1,802.63,1127.15Z"
            />
            <path
              class={cls10}
              d="M734.49,1166.48c3.86,2.23,3.87,5.84,0,8.07a15.42,15.42,0,0,1-14,0c-3.86-2.23-3.85-5.84,0-8.07A15.42,15.42,0,0,1,734.49,1166.48Z"
            />
            <line
              class={cls12}
              x1="802.63"
              y1="1135.21"
              x2="856.8"
              y2="1166.48"
            />
            <line
              class={cls12}
              x1="856.8"
              y1="1174.55"
              x2="802.63"
              y2="1205.82"
            />
            <line
              class={cls12}
              x1="788.66"
              y1="1205.82"
              x2="734.49"
              y2="1174.55"
            />
            <line
              class={cls12}
              x1="734.49"
              y1="1166.48"
              x2="788.66"
              y2="1135.21"
            />
            <polygon
              class={cls12}
              points="795.64 1183.76 772.7 1170.51 795.64 1157.27 818.59 1170.51 795.64 1183.76"
            />
            <path
              class={cls12}
              d="M802.63,1135.21c3.86-2.23,3.85-5.84,0-8.06a15.42,15.42,0,0,0-14,0c-3.86,2.22-3.87,5.83,0,8.06A15.42,15.42,0,0,0,802.63,1135.21Z"
            />
            <path
              class={cls12}
              d="M856.8,1174.55a15.42,15.42,0,0,0,14,0c3.86-2.23,3.85-5.84,0-8.07a15.45,15.45,0,0,0-14,0C852.94,1168.71,852.94,1172.33,856.8,1174.55Z"
            />
            <path
              class={cls12}
              d="M788.66,1205.82c-3.86,2.23-3.86,5.84,0,8.07a15.42,15.42,0,0,0,14,0c3.86-2.23,3.85-5.84,0-8.07A15.45,15.45,0,0,0,788.66,1205.82Z"
            />
            <path
              class={cls12}
              d="M734.49,1174.55c3.87-2.23,3.86-5.84,0-8.07a15.42,15.42,0,0,0-14,0c-3.85,2.23-3.86,5.84,0,8.07A15.42,15.42,0,0,0,734.49,1174.55Z"
            />
            <path
              class={cls7}
              d="M401.89,894.77c57.74,33.33,57.74,87.38,0,120.71-1,.57-2,1.13-3,1.67V903.73l-3.24-12.36C397.78,892.46,399.86,893.6,401.89,894.77Z"
            />
            <path
              class={cls11}
              d="M398.9,1017.15c-31.63,17.28-73.23,25-113.74,23V936.64L398.9,903.73Z"
            />
            <path
              class={cls8}
              d="M395.66,891.37l3.24,12.36L285.16,936.64,195.8,884.36l58.52-65.23,125.52,12Zm-57.57-1.85-7.21-27.46-47.46-4.53L261.3,882.2,295.08,902Z"
            />
            <polygon
              class={cls10}
              points="330.88 862.06 338.09 889.52 295.08 901.96 283.42 895.13 283.42 857.53 330.88 862.06"
            />
            <path
              class={cls10}
              d="M285.16,936.64v103.55c-32.38-1.53-64.06-9.22-89.36-23V893.09q3.88-2.13,8-4.06Z"
            />
            <polygon
              class={cls7}
              points="283.42 857.53 283.42 895.13 261.3 882.2 283.42 857.53"
            />
            <path class={cls10} d="M195.8,884.36l8,4.67q-4.09,1.92-8,4.06Z" />
            <path
              class={cls7}
              d="M195.8,893.09v124.07c-1-.54-2-1.11-3-1.68-57.74-33.33-57.74-87.38,0-120.71C193.8,894.2,194.79,893.64,195.8,893.09Z"
            />
            <polygon
              class={cls12}
              points="285.16 936.64 195.8 884.36 254.32 819.13 379.84 831.1 398.9 903.73 285.16 936.64"
            />
            <polygon
              class={cls12}
              points="283.42 857.53 330.88 862.06 338.09 889.52 295.08 901.96 261.3 882.2 283.42 857.53"
            />
            <line
              class={cls12}
              x1="195.8"
              y1="884.36"
              x2="195.8"
              y2="1017.16"
            />
            <line
              class={cls12}
              x1="285.16"
              y1="936.64"
              x2="285.16"
              y2="1040.19"
            />
            <line
              class={cls12}
              x1="398.9"
              y1="1017.15"
              x2="398.9"
              y2="903.73"
            />
            <path
              class={cls12}
              d="M395.66,891.37c2.12,1.09,4.2,2.23,6.23,3.4,57.74,33.33,57.74,87.38,0,120.71-1,.57-2,1.13-3,1.67-31.7,17.15-73.23,25-113.74,23-32.38-1.53-64-9.33-89.36-23-1-.54-2-1.11-3-1.68-57.74-33.33-57.74-87.38,0-120.71,1-.57,2-1.13,3-1.68q3.88-2.13,8-4.06"
            />
            <line
              class={cls12}
              x1="283.42"
              y1="857.53"
              x2="283.42"
              y2="895.13"
            />
            <polygon
              class={cls8}
              points="94.95 507.42 94.95 534.45 89.54 537.57 89.54 515.56 84.85 518.27 84.85 513.25 94.95 507.42"
            />
            <path
              class={cls7}
              d="M103.88,528.09a4.8,4.8,0,0,1-3.56-2.75A14.5,14.5,0,0,1,99,518.58a26.12,26.12,0,0,1,1.29-8.26,23.36,23.36,0,0,1,3.56-6.86,17.78,17.78,0,0,1,5.19-4.66,8.05,8.05,0,0,1,5.18-1.33,4.82,4.82,0,0,1,3.56,2.75A14.55,14.55,0,0,1,119.1,507a26,26,0,0,1-1.29,8.25,23.29,23.29,0,0,1-3.56,6.87,17.83,17.83,0,0,1-5.18,4.65A8,8,0,0,1,103.88,528.09Zm8.55-10.68a18.58,18.58,0,0,0,1.22-7.27c0-3-.41-4.92-1.22-5.86s-1.94-1-3.36-.19a8.2,8.2,0,0,0-3.33,4.05,18.4,18.4,0,0,0-1.22,7.27c0,3,.4,4.91,1.22,5.86s1.92,1,3.33.2A8.32,8.32,0,0,0,112.43,517.41Z"
            />
            <path
              class={cls9}
              d="M126.59,515a4.76,4.76,0,0,1-3.56-2.75,14.5,14.5,0,0,1-1.29-6.76,26.12,26.12,0,0,1,1.29-8.26,22.89,22.89,0,0,1,3.56-6.86,17.44,17.44,0,0,1,5.18-4.65,8.11,8.11,0,0,1,5.19-1.34,4.82,4.82,0,0,1,3.56,2.75,14.69,14.69,0,0,1,1.28,6.77,26.4,26.4,0,0,1-1.28,8.26A23.36,23.36,0,0,1,137,509a17.74,17.74,0,0,1-5.19,4.65A8,8,0,0,1,126.59,515Zm8.54-10.68a18.4,18.4,0,0,0,1.22-7.27c0-3-.4-4.91-1.22-5.86s-1.93-1-3.36-.19a8.31,8.31,0,0,0-3.33,4,18.58,18.58,0,0,0-1.22,7.27q0,4.44,1.22,5.86c.82.94,1.93,1,3.33.2A8.21,8.21,0,0,0,135.13,504.3Z"
            />
            <polygon
              class={cls7}
              points="153.27 473.74 153.27 500.77 147.86 503.9 147.86 481.89 143.18 484.6 143.18 479.57 153.27 473.74"
            />
            <path
              class={cls9}
              d="M162.2,494.42a4.82,4.82,0,0,1-3.56-2.75,14.52,14.52,0,0,1-1.29-6.77,26,26,0,0,1,1.29-8.25,23.36,23.36,0,0,1,3.56-6.86,17.64,17.64,0,0,1,5.19-4.66,8.07,8.07,0,0,1,5.18-1.33,4.8,4.8,0,0,1,3.56,2.75,14.52,14.52,0,0,1,1.29,6.77,26,26,0,0,1-1.29,8.25,23.06,23.06,0,0,1-3.56,6.87,17.7,17.7,0,0,1-5.18,4.65A8.1,8.1,0,0,1,162.2,494.42Zm8.55-10.69a18.5,18.5,0,0,0,1.22-7.26c0-3-.41-4.92-1.22-5.86s-1.94-1-3.36-.19a8.16,8.16,0,0,0-3.33,4.05,18.55,18.55,0,0,0-1.22,7.27q0,4.44,1.22,5.86c.81.94,1.92,1,3.33.2A8.3,8.3,0,0,0,170.75,483.73Z"
            />
            <polygon
              class={cls9}
              points="188.89 453.18 188.89 480.21 183.47 483.34 183.47 461.33 178.79 464.03 178.79 459.01 188.89 453.18"
            />
            <path
              class={cls7}
              d="M197.82,473.86a4.79,4.79,0,0,1-3.56-2.75,14.52,14.52,0,0,1-1.29-6.77,26,26,0,0,1,1.29-8.25,23,23,0,0,1,3.56-6.87,17.58,17.58,0,0,1,5.18-4.65,8.1,8.1,0,0,1,5.19-1.33,4.82,4.82,0,0,1,3.56,2.75,14.66,14.66,0,0,1,1.28,6.77,26.29,26.29,0,0,1-1.28,8.25,23.36,23.36,0,0,1-3.56,6.86,17.64,17.64,0,0,1-5.19,4.66A8.08,8.08,0,0,1,197.82,473.86Zm8.54-10.69a18.37,18.37,0,0,0,1.22-7.27c0-3-.4-4.91-1.22-5.86s-1.93-1-3.36-.18a8.26,8.26,0,0,0-3.33,4.05,18.55,18.55,0,0,0-1.22,7.27q0,4.44,1.22,5.85t3.33.21A8.24,8.24,0,0,0,206.36,463.17Z"
            />
            <polygon
              class={cls9}
              points="224.5 432.62 224.5 459.65 219.09 462.78 219.09 440.77 214.41 443.47 214.41 438.45 224.5 432.62"
            />
            <path
              class={cls7}
              d="M233.43,453.3a4.82,4.82,0,0,1-3.56-2.75,14.55,14.55,0,0,1-1.29-6.77,26,26,0,0,1,1.29-8.25,23.29,23.29,0,0,1,3.56-6.87,17.74,17.74,0,0,1,5.19-4.65,8.07,8.07,0,0,1,5.18-1.33,4.78,4.78,0,0,1,3.56,2.75,14.5,14.5,0,0,1,1.29,6.76,26.07,26.07,0,0,1-1.29,8.26,23.12,23.12,0,0,1-3.56,6.86,17.56,17.56,0,0,1-5.18,4.65A8.11,8.11,0,0,1,233.43,453.3ZM242,442.61a18.55,18.55,0,0,0,1.22-7.27q0-4.44-1.22-5.86c-.82-.94-1.94-1-3.36-.18a8.17,8.17,0,0,0-3.33,4,18.58,18.58,0,0,0-1.22,7.27c0,3,.41,4.92,1.22,5.86s1.92,1,3.33.2A8.27,8.27,0,0,0,242,442.61Z"
            />
            <polygon
              class={cls7}
              points="260.12 412.06 260.12 439.09 254.7 442.21 254.7 420.2 250.02 422.91 250.02 417.89 260.12 412.06"
            />
            <path
              class={cls9}
              d="M90.77,577.44a4.82,4.82,0,0,1-3.56-2.75,14.55,14.55,0,0,1-1.29-6.77,26,26,0,0,1,1.29-8.25,23.41,23.41,0,0,1,3.56-6.87A17.74,17.74,0,0,1,96,548.15a8.07,8.07,0,0,1,5.18-1.33,4.8,4.8,0,0,1,3.56,2.75,14.52,14.52,0,0,1,1.29,6.77,26.06,26.06,0,0,1-1.29,8.25,23.12,23.12,0,0,1-3.56,6.86A17.6,17.6,0,0,1,96,576.11,8.1,8.1,0,0,1,90.77,577.44Zm8.55-10.69a18.55,18.55,0,0,0,1.22-7.27q0-4.44-1.22-5.86T96,553.44a8.17,8.17,0,0,0-3.33,4,18.4,18.4,0,0,0-1.22,7.27c0,3,.4,4.92,1.22,5.86s1.92,1,3.33.21A8.35,8.35,0,0,0,99.32,566.75Z"
            />
            <polygon
              class={cls9}
              points="117.46 536.2 117.46 563.23 112.04 566.36 112.04 544.35 107.36 547.05 107.36 542.03 117.46 536.2"
            />
            <path
              class={cls7}
              d="M126.39,556.88a4.79,4.79,0,0,1-3.56-2.75,14.55,14.55,0,0,1-1.29-6.77,26.12,26.12,0,0,1,1.29-8.26,22.89,22.89,0,0,1,3.56-6.86,17.58,17.58,0,0,1,5.18-4.65,8.1,8.1,0,0,1,5.18-1.34,4.83,4.83,0,0,1,3.57,2.76,14.61,14.61,0,0,1,1.28,6.76,26.4,26.4,0,0,1-1.28,8.26,23.14,23.14,0,0,1-3.57,6.86,17.58,17.58,0,0,1-5.18,4.65A8.1,8.1,0,0,1,126.39,556.88Zm8.54-10.69a18.4,18.4,0,0,0,1.22-7.27c0-3-.4-4.91-1.22-5.86s-1.93-1-3.36-.18a8.28,8.28,0,0,0-3.33,4,18.58,18.58,0,0,0-1.22,7.27c0,3,.41,4.92,1.22,5.86s1.93,1,3.33.2A8.17,8.17,0,0,0,134.93,546.19Z"
            />
            <polygon
              class={cls9}
              points="153.07 515.64 153.07 542.67 147.66 545.79 147.66 523.78 142.97 526.49 142.97 521.47 153.07 515.64"
            />
            <path
              class={cls8}
              d="M162,536.31a4.8,4.8,0,0,1-3.56-2.75,14.5,14.5,0,0,1-1.29-6.76,26.12,26.12,0,0,1,1.29-8.26,23.36,23.36,0,0,1,3.56-6.86,17.78,17.78,0,0,1,5.19-4.66,8.07,8.07,0,0,1,5.18-1.33,4.8,4.8,0,0,1,3.56,2.75,14.55,14.55,0,0,1,1.29,6.77,26.12,26.12,0,0,1-1.29,8.26,23.12,23.12,0,0,1-3.56,6.86,17.7,17.7,0,0,1-5.18,4.65A8,8,0,0,1,162,536.31Zm8.55-10.68a18.58,18.58,0,0,0,1.22-7.27c0-3-.41-4.92-1.22-5.86s-1.94-1-3.36-.19a8.2,8.2,0,0,0-3.33,4.05,18.4,18.4,0,0,0-1.22,7.27c0,3,.4,4.91,1.22,5.86s1.92,1,3.33.2A8.32,8.32,0,0,0,170.55,525.63Z"
            />
            <polygon
              class={cls7}
              points="188.69 495.07 188.69 522.1 183.27 525.23 183.27 503.22 178.59 505.93 178.59 500.9 188.69 495.07"
            />
            <polygon
              class={cls9}
              points="201.8 487.5 201.8 514.53 196.38 517.66 196.38 495.65 191.7 498.36 191.7 493.34 201.8 487.5"
            />
            <path
              class={cls9}
              d="M210.73,508.18a4.79,4.79,0,0,1-3.57-2.75,14.64,14.64,0,0,1-1.28-6.76,26.4,26.4,0,0,1,1.28-8.26,23.14,23.14,0,0,1,3.57-6.86,17.62,17.62,0,0,1,5.18-4.66,8.08,8.08,0,0,1,5.18-1.33,4.79,4.79,0,0,1,3.56,2.75,14.55,14.55,0,0,1,1.29,6.77,26,26,0,0,1-1.29,8.25,22.83,22.83,0,0,1-3.56,6.87,17.58,17.58,0,0,1-5.18,4.65A8,8,0,0,1,210.73,508.18Zm8.54-10.68a18.58,18.58,0,0,0,1.22-7.27c0-3-.41-4.92-1.22-5.86s-1.93-1-3.36-.19a8.26,8.26,0,0,0-3.33,4.05,18.58,18.58,0,0,0-1.22,7.27q0,4.44,1.22,5.86c.82.94,1.93,1,3.33.2A8.21,8.21,0,0,0,219.27,497.5Z"
            />
            <path
              class={cls7}
              d="M233.43,495.07a4.8,4.8,0,0,1-3.56-2.75,14.5,14.5,0,0,1-1.29-6.76,26.12,26.12,0,0,1,1.29-8.26,23.36,23.36,0,0,1,3.56-6.86,17.78,17.78,0,0,1,5.19-4.66,8.07,8.07,0,0,1,5.18-1.33,4.8,4.8,0,0,1,3.56,2.75,14.55,14.55,0,0,1,1.29,6.77,26,26,0,0,1-1.29,8.25,23.06,23.06,0,0,1-3.56,6.87,17.7,17.7,0,0,1-5.18,4.65A8,8,0,0,1,233.43,495.07ZM242,484.39a18.58,18.58,0,0,0,1.22-7.27c0-3-.41-4.92-1.22-5.86s-1.94-1-3.36-.19a8.16,8.16,0,0,0-3.33,4.05,18.58,18.58,0,0,0-1.22,7.27q0,4.44,1.22,5.86c.81.94,1.92,1,3.33.2A8.32,8.32,0,0,0,242,484.39Z"
            />
            <polygon
              class={cls9}
              points="260.12 453.83 260.12 480.86 254.7 483.99 254.7 461.98 250.02 464.68 250.02 459.66 260.12 453.83"
            />
            <path
              class={cls7}
              d="M90.77,619.22a4.83,4.83,0,0,1-3.56-2.76,14.47,14.47,0,0,1-1.29-6.76,26.12,26.12,0,0,1,1.29-8.26,23.36,23.36,0,0,1,3.56-6.86A17.74,17.74,0,0,1,96,589.93a8.08,8.08,0,0,1,5.18-1.34,4.82,4.82,0,0,1,3.56,2.76,14.47,14.47,0,0,1,1.29,6.76,26.12,26.12,0,0,1-1.29,8.26,23.12,23.12,0,0,1-3.56,6.86A17.7,17.7,0,0,1,96,617.88,8.11,8.11,0,0,1,90.77,619.22Zm8.55-10.69a18.58,18.58,0,0,0,1.22-7.27q0-4.44-1.22-5.86T96,595.22a8.17,8.17,0,0,0-3.33,4,18.4,18.4,0,0,0-1.22,7.27c0,3,.4,4.91,1.22,5.86s1.92,1,3.33.2A8.32,8.32,0,0,0,99.32,608.53Z"
            />
            <path
              class={cls9}
              d="M113.48,606.11a4.8,4.8,0,0,1-3.56-2.75,14.55,14.55,0,0,1-1.29-6.77,26.12,26.12,0,0,1,1.29-8.26,23.12,23.12,0,0,1,3.56-6.86,17.58,17.58,0,0,1,5.18-4.65,8.11,8.11,0,0,1,5.19-1.34,4.83,4.83,0,0,1,3.56,2.76,14.48,14.48,0,0,1,1.28,6.76,26.12,26.12,0,0,1-1.28,8.26,23.36,23.36,0,0,1-3.56,6.86,17.74,17.74,0,0,1-5.19,4.65A8.1,8.1,0,0,1,113.48,606.11ZM122,595.42a18.4,18.4,0,0,0,1.22-7.27c0-3-.4-4.91-1.22-5.86s-1.93-1-3.36-.18a8.28,8.28,0,0,0-3.33,4,18.58,18.58,0,0,0-1.22,7.27c0,3,.41,4.92,1.22,5.86s1.93,1,3.33.2A8.17,8.17,0,0,0,122,595.42Z"
            />
            <polygon
              class={cls7}
              points="140.16 564.87 140.16 591.9 134.75 595.02 134.75 573.01 130.06 575.72 130.06 570.7 140.16 564.87"
            />
            <polygon
              class={cls9}
              points="153.27 557.3 153.27 584.33 147.86 587.46 147.86 565.45 143.18 568.15 143.18 563.13 153.27 557.3"
            />
            <path
              class={cls7}
              d="M162.2,578a4.83,4.83,0,0,1-3.56-2.76,14.47,14.47,0,0,1-1.29-6.76,26.12,26.12,0,0,1,1.29-8.26,23.36,23.36,0,0,1,3.56-6.86,17.74,17.74,0,0,1,5.19-4.65,8.08,8.08,0,0,1,5.18-1.34,4.82,4.82,0,0,1,3.56,2.76,14.47,14.47,0,0,1,1.29,6.76,26.12,26.12,0,0,1-1.29,8.26,23.12,23.12,0,0,1-3.56,6.86,17.7,17.7,0,0,1-5.18,4.65A8.11,8.11,0,0,1,162.2,578Zm8.55-10.69A18.58,18.58,0,0,0,172,560q0-4.44-1.22-5.86t-3.36-.18a8.17,8.17,0,0,0-3.33,4,18.58,18.58,0,0,0-1.22,7.27q0,4.44,1.22,5.86c.81,1,1.92,1,3.33.2A8.32,8.32,0,0,0,170.75,567.29Z"
            />
            <polygon
              class={cls9}
              points="188.89 536.74 188.89 563.76 183.47 566.89 183.47 544.88 178.79 547.59 178.79 542.57 188.89 536.74"
            />
            <polygon
              class={cls9}
              points="202 529.17 202 556.2 196.58 559.32 196.58 537.32 191.9 540.02 191.9 535 202 529.17"
            />
            <path
              class={cls7}
              d="M210.93,549.84a4.79,4.79,0,0,1-3.57-2.75,14.61,14.61,0,0,1-1.28-6.76,26.4,26.4,0,0,1,1.28-8.26,23.14,23.14,0,0,1,3.57-6.86,17.58,17.58,0,0,1,5.18-4.65,8.1,8.1,0,0,1,5.18-1.34,4.8,4.8,0,0,1,3.56,2.76,14.47,14.47,0,0,1,1.29,6.76,26.12,26.12,0,0,1-1.29,8.26,22.89,22.89,0,0,1-3.56,6.86,17.58,17.58,0,0,1-5.18,4.65A8,8,0,0,1,210.93,549.84Zm8.54-10.68a18.58,18.58,0,0,0,1.22-7.27q0-4.44-1.22-5.86t-3.36-.18a8.23,8.23,0,0,0-3.33,4,18.58,18.58,0,0,0-1.22,7.27q0,4.44,1.22,5.86c.82,1,1.93,1,3.33.2A8.21,8.21,0,0,0,219.47,539.16Z"
            />
            <path
              class={cls9}
              d="M233.63,536.73a4.8,4.8,0,0,1-3.56-2.75,14.47,14.47,0,0,1-1.29-6.76,26.12,26.12,0,0,1,1.29-8.26,23.36,23.36,0,0,1,3.56-6.86,17.74,17.74,0,0,1,5.19-4.65,8.08,8.08,0,0,1,5.18-1.34,4.82,4.82,0,0,1,3.56,2.76,14.47,14.47,0,0,1,1.29,6.76,26.12,26.12,0,0,1-1.29,8.26,23.12,23.12,0,0,1-3.56,6.86,17.7,17.7,0,0,1-5.18,4.65A8,8,0,0,1,233.63,536.73Zm8.55-10.68a18.58,18.58,0,0,0,1.22-7.27q0-4.44-1.22-5.86t-3.36-.18a8.17,8.17,0,0,0-3.33,4,18.58,18.58,0,0,0-1.22,7.27q0,4.44,1.22,5.86c.81,1,1.92,1,3.33.2A8.32,8.32,0,0,0,242.18,526.05Z"
            />
            <polygon
              class={cls8}
              points="260.32 495.49 260.32 522.52 254.9 525.65 254.9 503.64 250.22 506.35 250.22 501.32 260.32 495.49"
            />
            <polygon
              class={cls9}
              points="979.01 72.42 979.01 99.45 973.59 102.57 973.59 80.56 968.91 83.27 968.91 78.25 979.01 72.42"
            />
            <polygon
              class={cls7}
              points="992.12 64.85 992.12 91.88 986.7 95 986.7 73 982.02 75.7 982.02 70.68 992.12 64.85"
            />
            <polygon
              class={cls7}
              points="1005.23 57.28 1005.23 84.31 999.81 87.44 999.81 65.43 995.13 68.13 995.13 63.11 1005.23 57.28"
            />
            <path
              class={cls8}
              d="M1014.15,78a4.82,4.82,0,0,1-3.56-2.75,14.56,14.56,0,0,1-1.28-6.77,26.12,26.12,0,0,1,1.28-8.26,23.36,23.36,0,0,1,3.56-6.86,17.74,17.74,0,0,1,5.19-4.65,8,8,0,0,1,5.18-1.33,4.78,4.78,0,0,1,3.56,2.75,14.5,14.5,0,0,1,1.29,6.76,26.12,26.12,0,0,1-1.29,8.26,23.12,23.12,0,0,1-3.56,6.86,17.7,17.7,0,0,1-5.18,4.65A8.11,8.11,0,0,1,1014.15,78Zm8.55-10.69a18.58,18.58,0,0,0,1.22-7.27q0-4.44-1.22-5.86c-.82-.94-1.94-1-3.36-.18a8.17,8.17,0,0,0-3.33,4,18.58,18.58,0,0,0-1.22,7.27c0,3,.41,4.92,1.22,5.86s1.92,1,3.33.2A8.27,8.27,0,0,0,1022.7,67.27Z"
            />
            <polygon
              class={cls7}
              points="1040.84 36.72 1040.84 63.75 1035.42 66.88 1035.42 44.87 1030.74 47.57 1030.74 42.55 1040.84 36.72"
            />
            <polygon
              class={cls7}
              points="768 912.11 768 939.14 762.58 942.27 762.58 920.26 757.89 922.96 757.89 917.94 768 912.11"
            />
            <path
              class={cls8}
              d="M776.92,932.79a4.82,4.82,0,0,1-3.56-2.75,14.52,14.52,0,0,1-1.29-6.77,26,26,0,0,1,1.29-8.25,23.41,23.41,0,0,1,3.56-6.87,17.74,17.74,0,0,1,5.19-4.65,8.07,8.07,0,0,1,5.18-1.33,4.8,4.8,0,0,1,3.56,2.75,14.52,14.52,0,0,1,1.29,6.77,26,26,0,0,1-1.29,8.25,23.12,23.12,0,0,1-3.56,6.86,17.6,17.6,0,0,1-5.18,4.66A8.1,8.1,0,0,1,776.92,932.79Zm8.55-10.69a18.55,18.55,0,0,0,1.22-7.27q0-4.44-1.22-5.86t-3.36-.18a8.17,8.17,0,0,0-3.33,4,18.58,18.58,0,0,0-1.22,7.27c0,3,.41,4.92,1.22,5.86s1.92,1,3.33.21A8.35,8.35,0,0,0,785.47,922.1Z"
            />
            <polygon
              class={cls7}
              points="803.61 891.55 803.61 918.58 798.19 921.71 798.19 899.7 793.51 902.4 793.51 897.38 803.61 891.55"
            />
            <polygon
              class={cls9}
              points="816.72 883.98 816.72 911.01 811.3 914.14 811.3 892.13 806.62 894.83 806.62 889.81 816.72 883.98"
            />
            <path
              class={cls7}
              d="M825.65,904.66a4.79,4.79,0,0,1-3.56-2.75,14.55,14.55,0,0,1-1.29-6.77,26,26,0,0,1,1.29-8.25,23,23,0,0,1,3.56-6.87,17.58,17.58,0,0,1,5.18-4.65A8.08,8.08,0,0,1,836,874a4.82,4.82,0,0,1,3.57,2.75,14.66,14.66,0,0,1,1.28,6.77,26.29,26.29,0,0,1-1.28,8.25,23.14,23.14,0,0,1-3.57,6.86,17.48,17.48,0,0,1-5.18,4.66A8.08,8.08,0,0,1,825.65,904.66ZM834.19,894a18.37,18.37,0,0,0,1.22-7.27c0-3-.4-4.91-1.22-5.86s-1.93-1-3.36-.18a8.28,8.28,0,0,0-3.33,4,18.58,18.58,0,0,0-1.22,7.27c0,3,.41,4.92,1.22,5.86s1.93,1,3.33.21A8.24,8.24,0,0,0,834.19,894Z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
